import { gql } from '@apollo/client';
import PROVISIONING_RESULT from 'graph/fragments/provisioning-result';

const UNLOCK_MASTERCODE = gql`
  mutation unlockMastercode($mastercodeId: Int!) {
    unlockMastercode(where: { id: $mastercodeId }) {
      ...BaseProvisioningResultFragment
    }
  }
  ${PROVISIONING_RESULT}
`;

export default UNLOCK_MASTERCODE;
